import React from "react";

/**
 * Shared hero content used on the main medical page and every medical subpage.
 * Structure: heading → subheading → first para → image → credibility/stats → second para.
 */
export const SHARED_HERO_SUBHEADING =
  "REPEXO Medical Personalberatung – Spezialisten für die Besetzung von Medizinstellen und Praxisnachfolge.";

export const SHARED_HERO_INTRO =
  "Seit  40 Jahren unterstützt REPEXO erfolgreich Unternehmen im Gesundheitswesen bei der Suche nach qualifizierten Fach- und Führungskräften. Durch unsere Spezialisierung auf den medizinischen Bereich verfügen wir über tiefgehende Branchenkenntnisse und verstehen die besonderen rechtlichen, wirtschaftlichen und organisatorischen Anforderungen dieser Branche.";

export const SHARED_HERO_CREDIBILITY = {
  ratingText: (
    <>
      Bewertung <strong>5/5</strong> & vertraut von führenden Unternehmen
    </>
  ),
  showAvatars: true,
  stats: [
    { value: "40+", label: "Jahre Erfahrung" },
    { value: "4000+", label: "erfolgreiche Personalsuch-Mandate" },
    { value: "FOCUS Top Personalberater", label: "Seit 2021 in Folge" },
  ],
};

export const SHARED_HERO_BOTTOM_PARAGRAPH =
  "Als eine der marktführenden Personalberatungen im Bereich Direktansprache / Executive Search identifizieren wir gezielt passende Kandidaten im verdeckten Arbeitsmarkt und bringen medizinische Einrichtungen mit hochqualifizierten Fachkräften zusammen. Unsere Erfahrung, unser Netzwerk und unsere strukturierte Suchmethodik ermöglichen eine präzise und nachhaltige Besetzung wichtiger Positionen.";
